import emptyState from 'assets/images/composition/empty-state.webp';
import styles from './EmptyWarning.module.scss';

interface EmptyWarningProps {
  title?: string;
  subtitle?: string;
  text?: string;
  fullWidth?: boolean;
}

function EmptyWarning({
  title = 'Ops!',
  subtitle = 'Dados não encontrados.',
  text = 'Em caso de dúvida, entre em contato com o(a) professor(a) responsável.',
  fullWidth,
}: EmptyWarningProps): JSX.Element {
  return (
    <div className={styles.container} data-fullwidth={fullWidth}>
      <h1>{title}</h1>
      <p>{subtitle}</p>
      <p>{text}</p>
      <img src={emptyState} width="70%" alt="Conteúdo inexistente" />
    </div>
  );
}

export default EmptyWarning;
